import { bus } from '@core/events/eventSystem';
import constants from '@core/utils/constants';
import { EVENTS } from './constants';

// Mock tickets data - adaptés pour l'Afrique de l'Ouest
const MOCK_TICKETS = [
  {
    id: '1',
    title: 'Concert de Angélique Kidjo - Africa Forever',
    mainImage: 'https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?w=800',
    images: [
      'https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?w=800',
      'https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?w=800',
      'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=800',
      'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=800'
    ],
    date: '12 Juillet 2025',
    time: '20h00',
    venue: 'Palais des Congrès de Cotonou',
    city: 'Cotonou',
    country: 'Bénin',
    address: 'Boulevard de la Marina, Cotonou',
    price: 15000,
    category: 'Concerts',
    hot: true,
    rating: 4.95,
    reviewCount: 847,
    organizer: {
      name: 'Kidjo Productions',
      eventCount: 45,
      rating: 4.9
    },
    description: 'Vivez une soirée exceptionnelle avec la diva béninoise Angélique Kidjo. Une expérience unique mêlant musique traditionnelle africaine et sons contemporains.',
    highlights: [
      'Place numérotée assise',
      'Accès VIP disponible',
      'Service de sécurité sur place',
      'Photo avec l\'artiste (VIP)',
      'Accès PMR',
      'Parking gratuit'
    ],
    dates: [
      '12 Juillet 2025 - 20h00',
      '13 Juillet 2025 - 21h00',
      '14 Juillet 2025 - 20h30'
    ],
    remainingSeats: 45
  },
  {
    id: '2',
    title: 'Grand Gala de Musique Traditionnelle',
    mainImage: 'https://images.unsplash.com/photo-1471478331149-c72f17e33c73?w=800',
    images: [
      'https://images.unsplash.com/photo-1471478331149-c72f17e33c73?w=800',
      'https://images.unsplash.com/photo-1506157786151-b8491531f063?w=800'
    ],
    date: '15 Août 2025',
    time: '19h00',
    venue: 'Place de l\'Étoile',
    city: 'Porto-Novo',
    country: 'Bénin',
    price: 5000,
    category: 'Concerts',
    hot: true,
    rating: 4.85,
    reviewCount: 423,
    organizer: {
      name: 'Ministère de la Culture du Bénin',
      eventCount: 120,
      rating: 4.7
    },
    description: 'Un spectacle magique de tambours, danses et chants traditionnels du Bénin. Célébration de notre patrimoine culturel immatériel.',
    highlights: [
      'Plus de 100 artistes',
      'Authenticité garantie',
      'Stands d\'artisanat',
      'Plats locaux disponibles',
      'Espace familial'
    ],
    dates: [
      '15 Août 2025 - 19h00'
    ],
    remainingSeats: 120
  },
  {
    id: '3',
    title: 'Buffles du Bénin vs Éléphants du Ghana',
    mainImage: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=800',
    images: [
      'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=800'
    ],
    date: '22 Septembre 2025',
    time: '16h00',
    venue: 'Stade de l\'Amitié',
    city: 'Cotonou',
    country: 'Bénin',
    price: 3000,
    category: 'Sports',
    hot: true,
    rating: 4.75,
    reviewCount: 612,
    organizer: {
      name: 'Fédération Béninoise de Football',
      eventCount: 85,
      rating: 4.6
    },
    description: 'Match amical international entre le Bénin et le Ghana. Une rencontre passionante pour soutenir nos Buffles!',
    highlights: [
      'Tribunes officielles',
      'Supporters disponibles',
      'Buvettes sur place',
      'Sécurité renforcée',
      'Parking payant'
    ],
    dates: [
      '22 Septembre 2025 - 16h00'
    ],
    remainingSeats: 5000
  },
  {
    id: '4',
    title: 'Festival Vodoun à Ouidah',
    mainImage: 'https://images.unsplash.com/photo-1506157786151-b8491531f063?w=800',
    images: [
      'https://images.unsplash.com/photo-1506157786151-b8491531f063?w=800'
    ],
    date: '10 Janvier 2026',
    time: '09h00',
    venue: 'Place du Château',
    city: 'Ouidah',
    country: 'Bénin',
    price: 8000,
    category: 'Festivals',
    hot: true,
    rating: 4.95,
    reviewCount: 2156,
    organizer: {
      name: 'UNESCO Bénin',
      eventCount: 30,
      rating: 4.9
    },
    description: 'Le célèbre festival Vodoun à Ouidah. Célébration des religions traditionnelles avec danses, cérémonies et défilés.',
    highlights: [
      'Cérémonies authentiques',
      'Défilé de 10km',
      'Artisans locaux',
      'Exposition culturelle',
      'Visite guidée de la Route des Esclaves'
    ],
    dates: [
      '10 Janvier 2026 - 09h00',
      '11 Janvier 2026 - 09h00'
    ],
    remainingSeats: 0
  },
  {
    id: '5',
    title: 'Spectacle de Danse Contemporaine - Terre d\'Afrique',
    mainImage: 'https://images.unsplash.com/photo-1508700929628-666bc8bd84ea?w=800',
    images: [
      'https://images.unsplash.com/photo-1508700929628-666bc8bd84ea?w=800'
    ],
    date: '5 Octobre 2025',
    time: '20h00',
    venue: 'Institut Français du Bénin',
    city: 'Cotonou',
    country: 'Bénin',
    price: 7500,
    category: 'Théâtre',
    hot: false,
    rating: 4.7,
    reviewCount: 189,
    organizer: {
      name: 'Compagnie Dansac',
      eventCount: 25,
      rating: 4.8
    },
    description: 'Un spectacle de danse contemporaine explorant les racines africaines. Performance époustouflante de danseurs professionnels.',
    highlights: [
      '20 danseurs professionnels',
      'Musique live',
      'Décors spectaculaires',
      'Durée: 1h30',
      'Rencontre avec les artistes'
    ],
    dates: [
      '5 Octobre 2025 - 20h00',
      '6 Octobre 2025 - 20h00'
    ],
    remainingSeats: 85
  },
  {
    id: '6',
    title: 'One Man Show - Kpotivi "Le Humoriste"',
    mainImage: 'https://images.unsplash.com/photo-1585699324551-f6c309eedeca?w=800',
    images: [
      'https://images.unsplash.com/photo-1585699324551-f6c309eedeca?w=800'
    ],
    date: '18 Novembre 2025',
    time: '20h30',
    venue: 'Canal Olympia',
    city: 'Cotonou',
    country: 'Bénin',
    price: 4000,
    category: 'Humour',
    hot: true,
    rating: 4.8,
    reviewCount: 534,
    organizer: {
      name: 'Event Partner Bénin',
      eventCount: 60,
      rating: 4.5
    },
    description: 'Le roi de l\'humour béninois est de retour! Une soirée de rires garantie avec son nouveau spectacle "Les tribulations d\'un fonctionnaire".',
    highlights: [
      '2 heures de spectacle',
      'Première partie avec DJ',
      'Cocktail offert',
      'Place assise',
      'VIP disponible'
    ],
    dates: [
      '18 Novembre 2025 - 20h30',
      '19 Novembre 2025 - 20h30'
    ],
    remainingSeats: 120
  },
  {
    id: '7',
    title: 'Conférence - L\'Entrepreneuriat Digital en Afrique',
    mainImage: 'https://images.unsplash.com/photo-1544531696-60c348f9e2d7?w=800',
    images: [
      'https://images.unsplash.com/photo-1544531696-60c348f9e2d7?w=800'
    ],
    date: '25 Octobre 2025',
    time: '09h00',
    venue: 'Novotel Cotonou',
    city: 'Cotonou',
    country: 'Bénin',
    price: 15000,
    category: 'Conférences',
    hot: false,
    rating: 4.6,
    reviewCount: 145,
    organizer: {
      name: 'Africa Tech Summit',
      eventCount: 15,
      rating: 4.7
    },
    description: 'Rencontrez les plus grands entrepreneurs africains du digital. Networking, ateliers et inspirations au programme.',
    highlights: [
      '15 conférenciers',
      'Ateliers pratiques',
      'Networking lunch',
      'Certificat de participation',
      'Goodie bag'
    ],
    dates: [
      '25 Octobre 2025 - 09h00'
    ],
    remainingSeats: 200
  },
  {
    id: '8',
    title: 'Tournoi de Basketball - AfroLeague Cotonou',
    mainImage: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=800',
    images: [
      'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=800'
    ],
    date: '15 Décembre 2025',
    time: '18h00',
    venue: 'Palais des Sports',
    city: 'Cotonou',
    country: 'Bénin',
    price: 2500,
    category: 'Sports',
    hot: true,
    rating: 4.7,
    reviewCount: 378,
    organizer: {
      name: 'Fédération Béninoise de Basketball',
      eventCount: 40,
      rating: 4.6
    },
    description: 'Finale du championnat national. Les meilleures équipes du Bénin s\'affrontent pour le titre.',
    highlights: [
      'Match + podium',
      'Animations de mi-temps',
      'Mascotte',
      'Tirages au sort',
      'Commentaires live'
    ],
    dates: [
      '15 Décembre 2025 - 18h00'
    ],
    remainingSeats: 800
  },
  {
    id: '9',
    title: 'Concert de Fally Ipupura - Kinsha',
    mainImage: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=800',
    images: [
      'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=800'
    ],
    date: '20 Décembre 2025',
    time: '21h00',
    venue: 'Stade de l\'Amitié',
    city: 'Lomé',
    country: 'Togo',
    price: 12000,
    category: 'Concerts',
    hot: true,
    rating: 4.9,
    reviewCount: 1200,
    organizer: {
      name: 'Fally Ipupura Productions',
      eventCount: 35,
      rating: 4.8
    },
    description: 'La star congolaise Fally Ipupura en concert à Lomé. Une soirée de musique ndombolo!',
    highlights: [
      '3 heures de concert',
      'Invités surprise',
      'DJ set après concert',
      'Stands de merchandise',
      'Parking sécurisé'
    ],
    dates: [
      '20 Décembre 2025 - 21h00'
    ],
    remainingSeats: 500
  },
  {
    id: '10',
    title: 'Festival Jazz de Ouagadougou',
    mainImage: 'https://images.unsplash.com/photo-1511192336529-518bd0eeb617?w=800',
    images: [
      'https://images.unsplash.com/photo-1511192336529-518bd0eeb617?w=800'
    ],
    date: 'Avril 2026',
    time: '19h00',
    venue: 'Centre Culturel',
    city: 'Ouagadougou',
    country: 'Burkina Faso',
    price: 10000,
    category: 'Festivals',
    hot: true,
    rating: 4.85,
    reviewCount: 890,
    organizer: {
      name: 'Jazz à Ouaga',
      eventCount: 25,
      rating: 4.7
    }
  },
  {
    id: '11',
    title: 'Concert de Magic System - Premier Gaou',
    mainImage: 'https://images.unsplash.com/photo-1501612780327-45045538702b?w=800',
    images: [
      'https://images.unsplash.com/photo-1501612780327-45045538702b?w=800'
    ],
    date: '15 Août 2025',
    time: '22h00',
    venue: 'Hôtel Ivoire',
    city: 'Abidjan',
    country: 'Côte d\'Ivoire',
    price: 18000,
    category: 'Concerts',
    hot: true,
    rating: 4.9,
    reviewCount: 2100,
    organizer: {
      name: 'Showtime Côte d\'Ivoire',
      eventCount: 80,
      rating: 4.8
    }
  },
  {
    id: '12',
    title: 'Festival Hip Hop Dakar',
    mainImage: 'https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?w=800',
    images: [
      'https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?w=800'
    ],
    date: '5 Décembre 2025',
    time: '18h00',
    venue: 'Grand Théâtre',
    city: 'Dakar',
    country: 'Sénégal',
    price: 8000,
    category: 'Festivals',
    hot: true,
    rating: 4.8,
    reviewCount: 650,
    organizer: {
      name: 'Africulture Festival',
      eventCount: 40,
      rating: 4.7
    }
  },
  {
    id: '13',
    title: 'Match Mali vs Sénégal - Rugby',
    mainImage: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=800',
    images: [
      'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=800'
    ],
    date: '10 Novembre 2025',
    time: '16h00',
    venue: 'Stade Omnisports',
    city: 'Bamako',
    country: 'Mali',
    price: 5000,
    category: 'Sports',
    hot: true,
    rating: 4.7,
    reviewCount: 420,
    organizer: {
      name: 'Fédération Malienne de Rugby',
      eventCount: 30,
      rating: 4.6
    }
  }
];

class MockHandler {
  constructor() {
    this.setupNetworkIntercept();
  }

  setupNetworkIntercept() {
    // Intercept network requests and provide mock responses
    bus.on(constants.EVENTS.NETWORK.REQUEST, (request) => {
      // Simulate network delay
      setTimeout(() => {
        this.handleRequest(request);
      }, 300);
    });
  }

  handleRequest(request) {
    const { url, method, id: requestId } = request;

    if (!url) return; // Skip if no url

    // Tickets endpoints
    if (url.startsWith('/tickets/') && url.endsWith('/1') && method === 'GET') {
      // Get ticket by ID
      const ticket = MOCK_TICKETS.find(t => t.id === '1');
      bus.emit(constants.EVENTS.NETWORK.RESPONSE, {
        id: requestId,
        data: ticket,
        error: null
      });
    } else if (url === '/tickets' && method === 'GET') {
      // List tickets
      bus.emit(constants.EVENTS.NETWORK.RESPONSE, {
        id: requestId,
        data: MOCK_TICKETS,
        error: null
      });
    }
    // Checkout endpoints
    else if (url === '/checkout/orders' && method === 'POST') {
      // Create order
      bus.emit(constants.EVENTS.NETWORK.RESPONSE, {
        id: requestId,
        data: {
          orderId: 'ORD-' + Date.now(),
          status: 'pending',
          createdAt: new Date().toISOString()
        },
        error: null
      });
    } else if (url === '/checkout/payment' && method === 'POST') {
      // Process payment
      const quantity = request.data.quantity || 1;
      bus.emit(constants.EVENTS.NETWORK.RESPONSE, {
        id: requestId,
        data: {
          orderId: request.data.orderId,
          paymentId: 'PAY-' + Date.now(),
          status: 'confirmed',
          amount: 15000 * quantity,
          currency: 'XOF'
        },
        error: null
      });
    } else if (url === '/checkout/promo/validate' && method === 'POST') {
      // Validate promo code
      const code = request.data.code;
      if (code === 'BIENVENUE10') {
        bus.emit(constants.EVENTS.NETWORK.RESPONSE, {
          id: requestId,
          data: {
            code: 'BIENVENUE10',
            discount: 1000,
            type: 'fixed'
          },
          error: null
        });
      } else if (code === 'SUMMER20') {
        bus.emit(constants.EVENTS.NETWORK.RESPONSE, {
          id: requestId,
          data: {
            code: 'SUMMER20',
            discount: 20,
            type: 'percent'
          },
          error: null
        });
      } else {
        bus.emit(constants.EVENTS.NETWORK.RESPONSE, {
          id: requestId,
          data: null,
          error: 'Code promo invalide'
        });
      }
    } else if (url === '/checkout/payment/methods' && method === 'GET') {
      // Get payment methods
      bus.emit(constants.EVENTS.NETWORK.RESPONSE, {
        id: requestId,
        data: [
          { id: 'card', name: 'Carte bancaire', enabled: true },
          { id: 'mobile_money', name: 'Mobile Money', enabled: true },
          { id: 'paypal', name: 'PayPal', enabled: true }
        ],
        error: null
      });
    }
    // Unknown endpoint - pass through
    else {
      // Don't respond, let the real network layer handle it
    }
  }
}

// Auto-instantiate when imported
const mockHandler = new MockHandler();

export default mockHandler;
